
  import Vue from 'vue';
  import {Component, Watch} from "vue-property-decorator";
  import router from './router';
  import {Getter, Mutation} from "vuex-class";
  import UserDataService from "../src/services/userdata.service";
  import AuthService from "../src/services/auth.service";
  import {keycloak, keycloakProviderLogoutConfig} from "@/utils/keycloak";

  @Component({
    components: {},
  })
  export default class App extends Vue {
    @Mutation('SET_HAS_OPEN_SKONTO_VOUCHERS', {namespace: 'userdata'})
    SET_HAS_OPEN_SKONTO_VOUCHERS!: (hasOpenSkontoVouchers: boolean) => void;

    @Getter('getHasOpenSkontoVouchers', {namespace: 'userdata'})
    private getHasOpenSkontoVouchers!: boolean;

    private drawer = null;

    private items: any[] = [];
    private username = "";

    // Seiten erst rendern, wenn die Rollen geladen sind (sonst fehlen rollenabhängige Elemente)
    private rolesLoaded = false;

    private testEnv = false;

    logout() {
      keycloak.logout(keycloakProviderLogoutConfig).then(() => {
        localStorage.removeItem("user");

      }, (error) => {
        console.error("Error logging out: ", error);
        alert("Error logging out");
        alert(JSON.stringify(error))
      });
    }

    getClass(blink: boolean) {
      if (blink) {
        return 'blink_me';
      }
    }

    @Watch('getHasOpenSkontoVouchers')
    onPropertyChanged1(value: string, oldValue: string) {
      this.buildMenu();
    }

    created() {
      this.loadDataAndSetDefaults();
    }

    async loadDataAndSetDefaults() {
      try {
        await Promise.all([
          AuthService.loadRoles(),
          AuthService.loadUserName()
        ]);
      } catch (error) {
        this.$notify({
          group: 'foo',
          title: 'Fehler',
          text: (error && error.message) || 'Ein unerwarteter Fehler ist aufgetreten.',
          type: 'error'
        });
        return;
      }

      this.rolesLoaded = true;

      try {
        const hasOpenSkontoVouchers = await UserDataService.getHasOpenSkontoVouchers();
        this.SET_HAS_OPEN_SKONTO_VOUCHERS(hasOpenSkontoVouchers);
      } catch (error) {
        this.$notify({
          group: 'foo',
          title: 'Fehler',
          text: (error && error.message) || 'Fehler beim Laden der Skonto-Belege.',
          type: 'error'
        });
      }
    }

    beforeUpdate() {
        this.buildMenu();
    }

    buildMenu() {
      if (process.env.VUE_APP_ENV === 'test') {
        this.testEnv = true;
      }
      if (localStorage.getItem("user")) {
        this.username = JSON.parse((localStorage.getItem("user") || '{}')).name;

        let userRoles: string[] = AuthService.getRoles();
        this.items = [];
        if (userRoles.indexOf("ROLE_MOHTAMIM_MUHASIB") >= 0) {
          this.items.push(
            {icon: 'mdi-database', text: 'Vendor Management', link: 'vendormanagement'},
            {icon: 'mdi-file-document-outline', text: 'Voucher erstellen', link: 'voucher-erstellen'},
            {icon: 'mdi-file-document-outline', text: 'Offene Voucher', link: 'openvouchers'},
            {icon: 'mdi-text-box-search-outline', text: 'Voucher Tracking', link: 'voucher-tracking'},
            {icon: 'mdi-archive', text: 'Archiv', link: 'voucher-archiv'}
          );
        } else if (userRoles.indexOf("ROLE_MOAWIN_MUHASIB") >= 0) {
          this.items.push(
            {icon: 'mdi-database', text: 'Vendor Management', link: 'vendormanagement'},
            {icon: 'mdi-file-document-outline', text: 'Voucher erstellen', link: 'voucher-erstellen'},
            {icon: 'mdi-file-document-outline', text: 'Offene Voucher', link: 'openvouchers'},
            {icon: 'mdi-archive', text: 'Archiv', link: 'voucher-archiv'}
          );
        } else if (userRoles.indexOf("ROLE_MOHTAMIM") >= 0) {
          this.items.push(
            {icon: 'mdi-file-document-outline', text: 'Voucher erstellen', link: 'voucher-erstellen'},
            {icon: 'mdi-file-document-outline', text: 'Offene Voucher', link: 'openvouchers'},
            {icon: 'mdi-text-box-search-outline', text: 'Voucher Tracking', link: 'voucher-tracking'}
          );
        } else if (userRoles.indexOf("ROLE_MOHTAMIM_MAAL") >= 0) {
          this.items.push(
            {icon: 'mdi-database', text: 'Vendor Management', link: 'vendormanagement'},
            {icon: 'mdi-file-document-outline', text: 'Voucher erstellen', link: 'voucher-erstellen'},
            {icon: 'mdi-file-document-outline', text: 'Offene Voucher', link: 'openvouchers'},
            {icon: 'mdi-text-box-search-outline', text: 'Voucher Tracking', link: 'voucher-tracking'},
            {icon: 'mdi-archive', text: 'Archiv', link: 'voucher-archiv'}
          );
        }
        else if (userRoles.indexOf("ROLE_MOHTAMIM_MAAL_ASSISTANT") >= 0) {
          this.items.push(
            {icon: 'mdi-database', text: 'Vendor Management', link: 'vendormanagement'},
            {icon: 'mdi-file-document-outline', text: 'Offene Voucher', link: 'openvouchers'},
            {icon: 'mdi-text-box-search-outline', text: 'Voucher Tracking', link: 'voucher-tracking'},
            {icon: 'mdi-archive', text: 'Archiv', link: 'voucher-archiv'}
          );
        }
        else {
          this.items.push(
            {icon: 'mdi-file-question-outline', text: 'Offene Voucher', link: 'openvouchers'},
            {icon: 'mdi-text-box-search-outline', text: 'Voucher Tracking', link: 'voucher-tracking'}
          );
        }
      }
    }

  }
